<template>
  <div class="share-button-div">
    <van-icon @click="handleShareClick" class="icon-btn" name="share-o" />
  </div>
  <KSShareStoreSharePopup v-model:show="sharePopupShow" @share:click="handleShareItemClick">
    <div class="share-title">Share</div>
    <div class="share-product-card">
      <img v-if="['Listing', 'Store'].indexOf(sourceType) > -1" v-lazy="shareImageUrl" alt="" class="product-image" />
      <p v-if="['Listing', 'Store'].indexOf(sourceType) > -1" class="product-name">{{ shareTitle }}</p>
      <div v-if="['Listing', 'Store'].indexOf(sourceType) <= -1">
        <img class="share-image" :src="shareImageUrl ? $cvWebpFn(shareImageUrl) : ''" >
        <p class="share-desc">{{ shareTitle }}</p>
      </div>
    </div>
  </KSShareStoreSharePopup>
</template>
<script lang="ts" setup>
import { share } from '@/components/KSShareStore/share'
import { getShareLink, type IShareLinkType } from '@/api/models/share'
import { customEventFn, eventName } from '@/plugins/bi-sa.client'
import { buildShareLinkTrafficSourceParams } from '@/plugins/utils'

const props = defineProps<{
  shareImageUrl: string, // 分享的图片
  shareTitle: string, // 分享的文案
  sourceType: string, // 分享类型 Listing, Article, Flashsale, GroupBuying, GroupBuyingTeam, ActivityPage, Store, NewArrival
  sourceId?: string | number // 分享源ID （sourceType 是 Listing, Article, GroupBuying, GroupBuyingTeam, ActivityPage, Store 时必填）
}>()
const { $sensors, $SENSORS_EVENT } = useNuxtApp()
const sharePopupShow = ref<boolean>(false)
const shareLinkTypeData = ref({})
const shareTypeValue = ref('shareProduct')
const handleShareClick = async () => {
  const params: IShareLinkType = {
    sourceType: props.sourceType as IShareLinkType['sourceType'],
    ...buildShareLinkTrafficSourceParams(props.sourceType)
  }
  if (props.sourceId) params.sourceId = props.sourceId
  shareLinkTypeData.value = await getShareLink(params)
  sharePopupShow.value = true
  $sensors.track(
    $SENSORS_EVENT.clickToShareButton,
    { 
      shareType: 'shareProduct'
    }
  )

  if (props.sourceType === 'Flashsale') {
    shareTypeValue.value ='shareFlashSale'
  } else if (props.sourceType === 'Store') {
    shareTypeValue.value ='shareStore'
  } else if (props.sourceType === 'NewArrival') {
    shareTypeValue.value ='shareNewArrval'
  } 
  customEventFn(eventName.clickToShareButton, {
    share_type: shareTypeValue.value
  })
}
const handleShareItemClick = (e: any) => {
  let url = `${useCurrentHost()}/listing/${props.listingId}?source=productDetails-share`
  let title = props.shareTitle
  if (shareLinkTypeData.value.code === 0) {
    // 取接口短链
    const shareLinkTypeList = shareLinkTypeData.value?.data?.templates || []
    shareLinkTypeList.forEach((item) => {
      if (e.key === 'Facebook' && item.channel === 'facebook' && item.code === 'link') {
        url = item.textEn
      }
      else if (e.key === 'WhatsApp' && item.channel === 'whatsapp' && item.code === 'link') {
        url = item.textEn
      }
      else if ((e.key === 'SMS' || e.key === 'CopyLink') && item.channel === '' && item.code === 'link') {
        url = item.textEn
      }
      else if (item.code === 'message') {
        title = item.textEn
      }
    })
  }

  share(
    e,
    { 
      href: url,
      title: title,
      shareContents: ''
    },
    shareTypeValue.value || 'shareProduct'
  )
}
 
</script>

<style lang="scss" scoped>
.share-button-div {
  width: 100%;
  .icon-btn {
    color: white;
    font-size: 40px;
  }
}
.share-title{
  color: #333;
  font-weight: 600;
  font-size: 36px;
  text-align: center;
  padding: 30px 0;
}
.share-product-card{
  display: flex;
  align-items: center;
  background-color: #f2f2f2;
  margin: 0 30px;
  border-radius: 10px;
  overflow: hidden;
  .product-image{
    width: 120px;
    border-radius: 10px;
    min-width: 120px;
    height: 120px;
    margin-right: 20px;
    object-fit: contain;
    background-color: #fff;
  }
  .share-image {
    width: 100%;
  }
  .share-desc {
    padding: 20px;
    margin-bottom: 20px;
    @include ellipsisMultiline(2);
    line-height: 40px;
    height: 100px;
    overflow: hidden;
  }
  .product-name{
    flex: 1;
    @include ellipsisMultiline(2);
    font-size: 26px;
    line-height: 40px;
    color: #333;
  }
}
</style>
